/* eslint-disable no-unused-vars */
// --- Imports --- //
import axios from 'axios';
import { useTranslation, Trans } from 'react-i18next';
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

// -- Services --- //
// import LogService, { useLogService } from 'services/LogService';

const PurposeService = class {
  // constructor(logService, recaptchaService) {
  constructor() {
    // Axios client initialization
    this.client = axios.create({
      baseURL: `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_SLOT_API_VERSION}/purpose`,
      validateStatus: function () {
        return true;
      },
      headers: { 'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_API_SUB_KEY}` }
    });
    // ReCaptcha Service
    // this.recaptchaService = recaptchaService || function () { };
    //Log Service
    // this.logService = logService || null;
  }

  async getPurposes(lang) {
    try {
      const { data: response, status } = await this.client.get('/get', {
        params: {
          locale: lang
        },});
      return response;
    } catch (error) {
      // console.log('error', error);
      return {};
    }
  }
};

export const usePurposeService = (props) => {
  //const { executeRecaptcha } = useGoogleReCaptcha();
  //const logService = useLogService('PurposeService');

  // return new PurposeService(logService, executeRecaptcha);
  return new PurposeService();
};

// export default new PurposeService(LogService('PurposeService'));
export default new PurposeService();
